import { Card, Heading, Icon } from '@frontendmentorio/design-system-v2';

export default function Pro() {
  return (
    <div className="pb-9 px-5">
      <div className="container-xl flex flex-col items-center gap-8">
      <div className="flex flex-col gap-5 items-center text-center">
          <Heading
            className="leading-snug max-w-[38rem]"
            level="3"
            tagName="h2"
          >
            Fast-track your developer career with{' '}
            <span className="bg-blue-500 font-bold leading-none px-2 rounded-lg text-white uppercase">
              Pro
            </span>
          </Heading>

          <p className="max-w-prose text-lg text-neutral-500">
            Get AI-powered feedback on every solution, build portfolio-worthy 
            projects, and master professional workflows with complete Figma 
            files—everything you need to level up faster.
          </p>
        </div>

        <ul className="flex flex-col gap-5 max-w-prose tablet:grid tablet:grid-cols-2 tablet:max-w-none desktop:grid-cols-3">
        <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="comment" />
            </span>

            <Heading level="5" tagName="h2">
              Level up faster with AI-powered feedback
            </Heading>

            <p className="text-neutral-500">
              Our AI-enhanced reports spot up to 3x more improvement opportunities 
              on every submission, giving you personalized insights that help you 
              level up faster.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="briefcase" />
            </span>

            <Heading level="5" tagName="h2">
              Build portfolio projects that get you hired
            </Heading>

            <p className="text-neutral-500">
              Create multi-page websites, interactive dashboards, and full-stack 
              applications with premium challenges that make your portfolio stand 
              out to employers.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="code" />
            </span>

            <Heading level="5" tagName="h2">
              Master the design-to-code workflow pros use
            </Heading>

            <p className="text-neutral-500">
              Learn to translate Figma designs into pixel-perfect code using 
              the same detailed specs and professional workflow that developers 
              use in real teams.
            </p>
          </Card>
        </ul>
      </div>
    </div>
  );
}
